import { useCallback, useEffect } from "react";
import { useBlocker } from "react-router-dom";

let globalUnblock: (() => void) | null = null;

type Props = { 
  blockNavigation: boolean 
  onBlock: (nextLocation: string) => void
}

export function useAppBlocker(props: Props): () => void {
  const { blockNavigation, onBlock } = props;

  const blocker = useBlocker(({ nextLocation }) => {
    if (blockNavigation) {
      // We do this because if we are not using the Shopify SaveBar the browser
      // address bar will change. For some reason I have to set it twice and it only changes on the second. 
      history.replaceState(null, "", "/");
      history.replaceState(null, "", `${location.pathname}${location.search}`);
    }

    onBlock(`${nextLocation.pathname}${nextLocation.search}`);
    return blockNavigation;
  });

  useEffect(() => {
    if (blockNavigation && blocker.reset) {
      globalUnblock = blocker.reset;
    } else {
      globalUnblock = null;
    }

    return () => {
      globalUnblock = null; // Cleanup on unmount
    };
  }, [blockNavigation, blocker]);

  return globalUnblock ? globalUnblock : () => {};
}

export function useAppUnblocker() {
  return useCallback(() => {
    if (globalUnblock) {
      globalUnblock();
      globalUnblock = null;
    }
  }, []);
}
